/*
  SaikoSpeed site chrome behavior.
  1. Priority+overflow nav: when the top-level items would wrap to a
     second row, trailing departments move into a "More" item until the
     row fits. Restores on resize.
  2. Flyout edge-awareness: nested sub-menus (left: 100%) that would
     leave the viewport open leftwards instead, which also keeps their
     hidden geometry from widening the page.
  Loaded with defer from layout/theme.liquid; re-runs on the editor's
  section reload events.
*/

(function () {
  'use strict';

  function initPriorityNav() {
    var nav = document.querySelector('.navigation-main');
    if (!nav || nav.querySelector('.saikospeed-nav-more')) return;

    var more = document.createElement('li');
    more.className = 'navigation-item has-sub-menu saikospeed-nav-more';
    more.innerHTML = '<a href="#" aria-haspopup="true">More</a><ul class="navigation-sub-menu"></ul>';
    more.querySelector('a').addEventListener('click', function (event) {
      event.preventDefault();
    });
    var moreList = more.querySelector('ul');
    nav.appendChild(more);

    function wrapped() {
      var items = Array.prototype.filter.call(nav.children, function (item) {
        return item.getBoundingClientRect().height > 0;
      });
      if (items.length < 2) return false;
      var firstTop = Math.round(items[0].getBoundingClientRect().top);
      return items.some(function (item) {
        return Math.round(item.getBoundingClientRect().top) > firstTop + 1;
      });
    }

    function rebalance() {
      while (moreList.firstChild) nav.insertBefore(moreList.firstChild, more);
      more.style.display = 'none';
      if (nav.getBoundingClientRect().height === 0) return;
      if (!wrapped()) return;
      more.style.display = '';
      var guard = 0;
      while (wrapped() && guard < 20) {
        var previous = more.previousElementSibling;
        if (!previous) break;
        moreList.insertBefore(previous, moreList.firstChild);
        guard++;
      }
    }

    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        rebalance();
        markEdgeFlyouts();
      }, 150);
    });
    rebalance();
  }

  function markEdgeFlyouts() {
    var flyoutWidth = 250;
    var bottomMargin = 24;
    var hosts = document.querySelectorAll(
      '.navigation-main > .navigation-item > .navigation-sub-menu .navigation-item.has-sub-menu'
    );
    Array.prototype.forEach.call(hosts, function (host) {
      var parentPanel = host.closest('.navigation-sub-menu');
      if (!parentPanel) return;
      var panelRight = parentPanel.getBoundingClientRect().right;
      host.classList.toggle(
        'saikospeed-flyout-left',
        panelRight + flyoutWidth > window.innerWidth
      );
      // Clamp the flyout to the viewport. The header pins, so the host's
      // viewport position is scroll-independent; init + resize suffice.
      var flyout = host.querySelector(':scope > .navigation-sub-menu');
      if (!flyout) return;
      var flyoutTop = host.getBoundingClientRect().top - 5;
      flyout.style.maxHeight = Math.max(120, window.innerHeight - flyoutTop - bottomMargin) + 'px';
    });
  }

  function init() {
    initPriorityNav();
    markEdgeFlyouts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
